import { cisInstance } from './cis-instance';
import { RegisterLogResponse } from '@/types';

/** История изменений реестра */
export const registerLog = {
    getByRegisterId: (registerId: string): Promise<RegisterLogResponse[]> =>
        cisInstance.get<RegisterLogResponse[]>(`RegisterLog/${registerId}`)
            .then(x => x.data),
};
